"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestIdProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const context_1 = require("./context");
const TestIdProvider = props => {
    const { children, testId = null } = props;
    return (0, jsx_runtime_1.jsx)(context_1.TestIdContext.Provider, { value: { testId }, children: children });
};
exports.TestIdProvider = TestIdProvider;
//# sourceMappingURL=provider.js.map